
const required = value => {
  if (!value || value.trim() === '') {
    return 'Required';
  }
  return undefined;
};

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

const maxLength5 = maxLength(5);

const isNumber = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;

const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;
  
const minValue1 = minValue(1);
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined;

  const noSpaces = value =>
  value && !/^\S+$/i.test(value) ?
  'Space is an invalid character.' : undefined;

  // For foreign postal codes.  For example, Canadian zip codes are usually input like this: M1R 0E9.  So allow spaces in the middle.
  const noLeadingOrTrailingSpaces = value =>
  value && !/^\S.+\S$/i.test(value) ?
  'Leading and trailing spaces are not allowed.' : undefined;

  const password = value => 
    value && !/^(?=.*\d).{8,}$/i.test(value) ?
    'Invalid password' : undefined;

const alphaNumeric = value =>
    value && /[^a-zA-Z0-9 ]/i.test(value) ? 
    'Alphanumeric characters only' : undefined;

export {
      required,
      maxLength,
      maxLength5,
      isNumber,
      minValue,
      minValue1,
      email,
      alphaNumeric,
      password,
      noSpaces,
      noLeadingOrTrailingSpaces
  };